import { soundCloudClientId } from '../../config';

/**
 * Whether SoundCloud is offered to the user at all - the route, the settings
 * button, the sign-in prompt in the player.
 *
 * Same gate as spotifyEnabled.ts, for the same reason: a route and a button
 * wired to a context nobody provides render against the `{}` default and do
 * nothing when pressed. Must agree with whether SoundCloudService is in the
 * provider tree in App.tsx - flip the two together.
 *
 * Sign-in also needs the backend's SoundCloudToken function deployed
 * (docs/SOUNDCLOUD.md section 2). Until it is, pressing "SoundCloud Login"
 * gets as far as the redirect back and then fails the code exchange with a
 * 404 from the function app - so this is the switch to leave off in a build
 * that goes out ahead of the backend - and it is off in any deployment
 * without a SoundCloud registration (VITE_SOUNDCLOUD_CLIENT_ID unset).
 */
export const soundCloudEnabled = soundCloudClientId !== '';
